import { supabase } from './supabase';

/**
 * Pings the Supabase edge function that pushes the message to the recipient's
 * mobile device. Best-effort: web senders should never fail to send a message
 * because the push fan-out is unavailable.
 */
export const notifyNewChatMessage = async (messageId: string) => {
  try {
    await supabase.functions.invoke('send-chat-push', { body: { messageId } });
  } catch (error) {
    console.warn('Chat push notification failed', error);
  }
};

/** Asks once for permission to raise desktop notifications for new messages. */
export async function ensureBrowserNotifications(): Promise<boolean> {
  if (typeof Notification === 'undefined') return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  return result === 'granted';
}

/** Shows a desktop notification when the tab is in the background. */
export function showBrowserNotification(title: string, body: string) {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
  if (document.visibilityState === 'visible') return;
  try {
    new Notification(title, { body, icon: '/assets/brand/icon.png', tag: 'daba-chat' });
  } catch {
    /* Some browsers require a service worker; silently ignore. */
  }
}
